/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: StandaloneFeature.ts
 * Project: mle-client-n
 * Committed last: 2022/11/9 @ 1645
 * ---
 * Description:
 */

import {Feature} from "./Feature";
import {FeaturesManager} from "./FeaturesManager";

/**
 * Represents a standalone feature, that does not use the Editor class
 * to implement the working logic. Usually is provided with a singleton
 * to make it globally accessible.
 */
export abstract class StandaloneFeature<TargetType> extends Feature<TargetType, void, void> {

    constructor(name: string, target: TargetType) {
        super(name, target, undefined, true);
    }

    destroy(): boolean {
        return false;
    }

    dataSelector(source: void): void | undefined {
        throw new Error("Standalone features are not meant to be used for getting some data");
    }

    init(initData: void | undefined): boolean {
        return false;
    }
}

export class StandaloneFeaturesManager extends FeaturesManager<void> {
}
